import React from "react";
import styled from "styled-components";
import {colourMapping} from "../../idea/IdeaType";
import {OpenIdeaRow} from "./OpenIdeaRow";

const Container = styled.div`
    margin-bottom: 10px;
`;

const Direction = styled.div`
    font-weight: bold;
    color: ${props => props.color}
`;

const Authors = styled.div`
    margin-left: 10px;
    margin-top: 5px;
`;

export const OpenIdeasList = ({ideas, ideaType, showDetail}) => {
    if (!ideas || !ideas.length) {
        return null;
    }

    const className = `t-open-${ideaType.toLowerCase()}s`;
    const titleColour = colourMapping[ideaType.toUpperCase()];
    const title = `${ideaType}s`;
    return <Container className={className}>
        <Direction color={titleColour}>{title}</Direction>
        <Authors className="t-authors">
            {ideas.map(idea => <OpenIdeaRow key={idea.ideaId} idea={idea} showDetail={showDetail}/>)}
        </Authors>
    </Container>;
};